import { Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import { DEFAULT_LOCALE_CODE } from '@ttc/ttc-constants/locale';
import { filter, take } from 'rxjs/operators';

import { LocaleManagerService } from '@main-client/src/app/locale-manager/locale-manager.service';
import { TranslationLocalStorageService } from '@main-client/src/app/translation-local-storage/translation-local-storage.service';

import { Memoize } from '@libs/src/functions/memoize';
import { IAppState } from '@main-client/src/app/app.state';

import isEmpty from 'lodash-es/isEmpty';

@Pipe({
  name: 'translationLookup',
})
export class TranslationLookupPipe implements PipeTransform {
  userState = this.store.select('user').pipe(
    filter((user) => !isEmpty(user)),
    take(1),
  );
  currentLocale: string = DEFAULT_LOCALE_CODE;

  constructor(
    private localeManagerService: LocaleManagerService,
    private store: Store<IAppState>,
    private translationStorageService: TranslationLocalStorageService,
  ) {
    this.userState.subscribe((user) => {
      this.currentLocale = this.localeManagerService.getLocaleForUser(user);
    });
  }

  transform(message: string, translationUnits: string[]) {
    return this.currentLocaleLookup({
      message,
      translationUnits,
      currentLocale: this.currentLocale,
    });
  }

  @Memoize()
  currentLocaleLookup({
    message,
    translationUnits,
    currentLocale,
  }: {
    message: string;
    translationUnits: string[];
    currentLocale: string;
  }): string {
    const localeMap =
      this.translationStorageService.getTranslationsMap()[currentLocale];
    return this.localeManagerService.getLocaleString(
      localeMap,
      message,
      translationUnits,
    );
  }
}
